import NomiconIcon from "./NomiconIcon";

export default NomiconIcon;
